import React from "react";
import Styled from 'styled-components';

const Container = Styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 48px;
  min-height: calc(100vh - 96px);
`;

const Doc = Styled.div`
  line-height: 1.3;
  h1 {
    font-weight: 600;
    font-size: 24px;
  }
  h2 {
    font-weight: 600;
    margin-top: 20px;
  }
  ol, ul {
    margin-left: 20px;
  }
  li, p {
    margin-top: 12px;
  }
  > ul {
    list-style: circle;
  }
  > ol {
    list-style: decimal;
    > ol {
      list-style: lower-alpha;
      > ol {
        list-style: lower-roman;
      }
    }
  }
`;

export default function Template({ data }) {
  const { markdownRemark } = data;
  const { html } = markdownRemark;
  return (
    <Container>
      <Doc dangerouslySetInnerHTML={{ __html: html }} />
    </Container>
  );
}

export const pageQuery = graphql`
  query DocBySlug($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        slug
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/doc.js